/*
	Insert Map.
	Google Maps - Javascript model.
*/
Maps =
{
	p_map_target : '.map-canvas',
	p_maps_counter: 1,
	init : function()
	{
		// Look for maps.
		if( jQuery(Maps.p_map_target).size() > 0 )
		{
			// Iterate through maps.
			jQuery(Maps.p_map_target).each(function(){
				
				// Get map options.
				var map_options = Maps.get_map_options( jQuery(this) );
				
				if( map_options.address != '' ) // Geocode map.
				{
					///Maps.set_map_with_address(map_options);
				}
				else // Longtitude and Latitude.
				{
					Maps.set_map(map_options);
				}
			});
		}
		
	},
	/*
		Render map with provided options.
	*/
	set_map : function( pm_options )
	{
		// Get options.
		var map_target = pm_options.target;
		var map_latitude = pm_options.latitude;
		var map_longitude = pm_options.longitude;
		var map_zoom = pm_options.zoom;
		var map_type = (typeof pm_options.type !== 'undefined') ? pm_options.type : '';
		var map_markers = pm_options.markers;
		var format = pm_options.format;
		
		// Get global map render options.
		var render_options = {};
		var map_render_options = Maps.get_map_render_options(render_options);
		
		// Assemble options for map render.
		var map_options = {
			div: '#' + map_target,
			lat: map_latitude,
			lng: map_longitude,
			zoom: map_zoom, //map_render_options.zoom,
			styles: map_render_options.map_custom_style,
			mapTypeId: map_render_options.type,
			scrollwheel: map_render_options.scroll_wheel,
			navigationControl: map_render_options.navigation_control,
			mapTypeControl: map_render_options.map_type_control,
			scaleControl: map_render_options.scale_control,
			draggable: map_render_options.draggable,
		}
		
		// Add Marker Clustering if applicable. (Using Marker Cluster Plus).
		if( map_markers.length > 0 )
		{
			// Options.
			var marker_clusterer = function(map) {
				options = {
					gridSize: 40,
					averageCenter: true,
					styles:[{
		            	url: map_render_options.icon_cluster.path,
						height: map_render_options.icon_cluster.height,
						width: map_render_options.icon_cluster.width,
						anchorIcon: [0, 0],
						textColor: map_render_options.icon_cluster.color,
						textSize: 16,
		            }]
        		}
				return new MarkerClusterer(map, [], options);
			}
			
			// Add to render object.
			map_options.markerClusterer = marker_clusterer;
		}
		
		// Render map. (using Gmaps.js)
		var map = new GMaps(map_options);
		
		// Set markers.
		if( map_markers.length > 0 )
		{
			// Track bounding for map markers.
			var bounds = new google.maps.LatLngBounds();
			
			//console.log('MARKER TIME, ',' ,Format: ',pm_options.format,'Options: ',pm_options,' , Settings: ',g_site_maps_info);
			//var location_icon_path = g_site_maps_info.options.icon_location.path;
			
			// Default Marker Icon Path to the Location Icon path.
			var marker_path = g_site_maps_info.options.icon_location.path; //map_render_options.location_icon_path;
			
			// Default marker icon to marker path.
			var marker_icon = marker_path;
			
			// Allow use of vector paths for location icon.
			// TODO: Options for anchor point.
			// https://developers.google.com/maps/documentation/javascript/markers
			var location_marker = map_render_options.icon_location;
			if( location_marker.type == 'svg' )
			{
				marker_icon = {
				  anchor: new google.maps.Point(27.5, 50),
				  url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(location_marker.svg.code)
				};
			}
			
			// Check for Area format. Reconfigure Marker Icon object.
			if( format == 'area' )
			{
				marker_path = g_site_maps_info.options.icon_area.path;
				marker_width = Number(g_site_maps_info.options.icon_area.width);
				marker_height = Number(g_site_maps_info.options.icon_area.height);
				marker_anchor_x = marker_width/2;
				marker_anchor_y = marker_height/2;
				
				marker_icon = {
					url: marker_path, //"https://www.coffscoastaccommodation.com.au/content/themes/nucleo-coffsaccom/dist/icons/map_circle.png", // url
					scaledSize: new google.maps.Size(marker_width, marker_height), // scaled size
					//origin: new google.maps.Point(0, 0), // origin
					anchor: new google.maps.Point(marker_anchor_x, marker_anchor_y), // anchor
				}
			}
			
			// Iterate through markers.
			// TODO: Add manual place card if unable to do otherwise.
			var markers = [];
			for(var i = 0; i < map_markers.length; i++)
			{
				// https://developers.google.com/maps/documentation/javascript/markers
				// https://jsfiddle.net/e52792j5/
				// https://iconmonstr.com/location-pin-thin-svg/
				// https://stackoverflow.com/questions/66268996/how-to-use-svg-with-multiple-paths-in-google-maps-marker-javascript
				var path = "M12 0c-4.198 0-8 3.403-8 7.602 0 6.243 6.377 6.903 8 16.398 1.623-9.495 8-10.155 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.342-3 3-3 3 1.343 3 3-1.343 3-3 3z";
				//var path = "M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z";
				//var path = "M-1.547 12l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM0 0q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z";
				//var path = "M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 7 6.602c0 3.455-2.563 7.543-7 14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602";
				var svgMarker = {
					path: path,
					fillColor: "blue",
					fillOpacity: 1,
					strokeWeight: 0,
					rotation: 0,
					scale: 2,
					anchor: new google.maps.Point(0, 20),
				};
				
				var svg_flat = '<svg width="55" height="55" viewBox="0 0 55 55" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"><g id="Accom_Marker_Pin.svg" transform="matrix(0.381529,0,0,0.381529,27.5287,24.7393)"><g transform="matrix(1,0,0,1,-36.3,-56.475)"><g id="Layer_1-2"><path d="M33.9,111.58C34.98,113.4 37.61,113.4 38.7,111.58C46.79,97.96 72.6,53.2 72.6,36.3C72.6,16.25 56.35,0 36.3,0C16.25,0 0,16.25 0,36.3C0,53.2 25.81,97.96 33.9,111.58Z" style="fill:rgb(35,81,105);fill-rule:nonzero;"/><path d="M39.42,44.69C40.55,44.02 41.84,43.42 43.42,42.9C43.99,42.71 44.63,42.53 45.31,42.35C47.19,41.85 49.41,41.33 51.55,40.6C55.75,39.16 59.63,36.86 59.95,32.16C60.48,24.65 52.45,23.22 46.76,24.95C45.31,25.41 44.05,26.14 42.94,27.05C42.11,27.74 41.35,28.53 40.68,29.42C40.23,30.02 39.81,30.66 39.42,31.33L39.42,28.11C39.42,23.52 37.43,20.43 34.27,18.71C33.93,18.53 33.58,18.36 33.22,18.2C31.41,17.44 29.3,17.07 26.99,17.07C18.88,17.07 16.15,21.5 14.86,24.28C13.57,26.98 14.48,29.69 16.53,30.14C17.04,30.27 17.52,30.25 17.97,30.14C18.82,29.92 19.51,29.31 19.83,28.53C20.05,28.02 20.1,27.43 19.94,26.84C19.41,24.66 17.21,23.76 18.35,21.36C19.49,18.81 21.84,17.38 26.76,17.38C28.74,17.38 30.12,17.99 31.09,19.07C31.46,19.48 31.78,19.96 32.04,20.5C32.57,21.61 32.86,22.99 33.03,24.54C33.16,25.76 33.21,27.09 33.21,28.5L33.21,35.19L33.19,35.19C32.06,35.86 30.77,36.46 29.19,36.98C28.62,37.17 27.98,37.35 27.3,37.53C25.42,38.03 23.2,38.55 21.06,39.28C16.86,40.72 12.98,43.02 12.66,47.72C12.13,55.23 20.16,56.66 25.85,54.93C27.3,54.47 28.56,53.74 29.67,52.83C30.5,52.14 31.26,51.35 31.93,50.46C32.38,49.86 32.8,49.22 33.19,48.55L33.19,51.77C33.19,56.36 35.18,59.45 38.34,61.17C38.68,61.35 39.03,61.52 39.39,61.68C41.2,62.44 43.31,62.81 45.62,62.81C53.73,62.81 56.46,58.38 57.75,55.6C59.04,52.9 58.13,50.19 56.08,49.74C55.57,49.61 55.09,49.63 54.64,49.74C53.79,49.96 53.1,50.57 52.78,51.35C52.56,51.86 52.51,52.45 52.67,53.04C53.2,55.22 55.4,56.12 54.26,58.52C53.12,61.07 50.77,62.5 45.85,62.5C43.87,62.5 42.49,61.89 41.52,60.81C41.15,60.4 40.83,59.92 40.57,59.38C40.04,58.27 39.75,56.89 39.58,55.34C39.45,54.12 39.4,52.79 39.4,51.38L39.4,44.69L39.42,44.69ZM39.42,31.71C39.85,30.97 40.32,30.26 40.84,29.59C41.53,28.7 42.31,27.89 43.2,27.19C43.89,26.64 44.65,26.16 45.47,25.77C50.17,23.52 55.55,25.92 54.72,33.88C54.42,36.56 53.1,38.28 51.39,39.47C49.54,40.76 47.25,41.43 45.29,41.99C44.5,42.22 43.75,42.43 43.12,42.67C41.54,43.27 40.4,43.79 39.42,44.39L39.42,31.7L39.42,31.71ZM33.18,48.16C32.75,48.9 32.28,49.61 31.76,50.28C31.07,51.17 30.29,51.98 29.4,52.68C28.71,53.23 27.95,53.71 27.13,54.1C22.43,56.35 17.05,53.95 17.88,45.99C18.18,43.31 19.5,41.59 21.21,40.4C23.06,39.11 25.35,38.44 27.31,37.88C28.1,37.65 28.85,37.44 29.48,37.2C31.06,36.6 32.2,36.08 33.18,35.48L33.18,48.17L33.18,48.16Z" style="fill:rgb(200,173,136);fill-rule:nonzero;"/></g></g></g></svg>';
				
				var svg_flat2 = g_site_maps_info.options.icon_location.svg.code;
				
				var svgMarker2 = {
				  anchor: new google.maps.Point(27.5, 45),
				  url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg_flat2)
				};
				
				// Assemble marker options.
				var marker_package = {
					lat: Number(map_markers[i].latitude),
					lng: Number(map_markers[i].longitude),
					icon: marker_icon, //svgMarker2, //svgMarker
					//clickable: true,
					//title: map_markers[i].title,
				};
				
				// Get info window data and validate.
				var info_window = map_markers[i].info_window + "";
				info_window = info_window.replace(/&amp;/g, "&");
				info_window = info_window.replace(/&lt;/g, "<");
				info_window = info_window.replace(/&gt;/g, ">");
				info_window = info_window.replace(/&quot;/g, "\"");
				info_window = info_window.replace(/&#039;/g, "'");
				
				// Assemble info window.
				var info_html = "";
				if( info_window != "0" )
				{
					info_html = info_window;
				}
				if( info_html != '' )
				{
					marker_package.infoWindow = {
						content: info_html
	            	}
				}
				
				// Add marker.
				var marker = map.addMarker(marker_package);
				
				// Add marker to marker list.
				markers.push(marker);
				
				// Add marker to bounds list.
				var marker_point = new google.maps.LatLng( Number(map_markers[i].latitude), Number(map_markers[i].longitude) );
				bounds.extend(marker_point);
			}
			
			// Fit markers.
			// Account for single markers. Widen bounds.
			if (bounds.getNorthEast().equals(bounds.getSouthWest())) // Single marker
			{
	        	map.setZoom( map_zoom );
	            map.setCenter( Number(map_markers[0].latitude), Number(map_markers[0].longitude) );
	        }
	        else // Multiple markers.
	        {
		    	map.fitBounds(bounds);
	        }
		}
	},
	/*
		Assemble the options to setup our map.
		Returns Latitude, Longitude, Address and Markers where applicable.
	*/
	get_map_options : function( pm_target )
	{
		var map_options = {};
		
		// g_site_maps_info is a maps info object inserted by WordPress.
		
		// Get options from attributes.
		var latitude = pm_target.find('.map-holder').attr('data-latitude');
		if( typeof latitude == 'undefined' ){ latitude = 0; };
		latitude = Number(latitude);
		var longitude = pm_target.find('.map-holder').attr('data-longitude');
		if( typeof longitude == 'undefined' ){ longitude = 0; };
		longitude = Number(longitude);
		var address = pm_target.find('.map-holder').attr('data-address');
		if( typeof address == 'undefined' ){ address = ''; };
		var zoom = pm_target.find('.map-holder').attr('data-zoom');
		if( typeof zoom == 'undefined' ){ zoom = g_site_maps_info.options.zoom; };
		zoom = Number(zoom);
		var format = pm_target.find('.map-holder').attr('data-format');
		if( typeof format == 'undefined' ){ format = 'default'; };
		
		// Give each map on page a unique ID.
		var attr_id = 'map-' + Maps.p_maps_counter;
		pm_target.find('.map-holder').attr('id',attr_id);
		Maps.p_maps_counter++;
		
		// Markers.
		///var marker_list = pm_target.find('.map-holder').attr('data-markers');
		// Get marker list from internal markup list.
		var marker_list = [];
		var markers_obj = pm_target.find('.markers-list');
		
		if( markers_obj.size() > 0 )
		{
			var marker_data_string = markers_obj.html();
			// Remove double quotes.
			marker_data_string = marker_data_string.replace(/[""]+/g, '"');//marker_data_string.replace("\"\"","\"");
			var marker_data = JSON.parse(marker_data_string);
			marker_list = marker_data;
		}
		
		// Assemble object to return.
		map_options.latitude = latitude;
		map_options.longitude = longitude;
		map_options.address = address;
		map_options.zoom = zoom;
		map_options.target = attr_id;
		map_options.markers = marker_list;
		map_options.format = format;
		
		return(map_options);
	},
	/*
		Assemble global render options for maps.
		Returns Zoom.
	*/
	get_map_render_options : function( pm_options )
	{
		/*
			g_site_maps_info is a maps info object inserted by WordPress.
		*/
		
		var map_render_options = {};
		
		// Zoom value.
		var map_zoom = 17;//(typeof pm_options.zoom != 'undefined') ? pm_options.zoom : 17;
		
		// Map Type.
		var map_type = google.maps.MapTypeId.ROADMAP;
		
		// Map graphics and styles.
		var location_icon_path = g_site_maps_info.options.icon_location.path;
		var map_custom_style = (g_site_maps_info.options.custom_style.profile) ? g_site_maps_info.options.custom_style.profile : '';
		if( map_custom_style != '' )
		{
			map_custom_style = JSON.parse( map_custom_style );
		}
		var icon_location = g_site_maps_info.options.icon_location;
		var icon_cluster = g_site_maps_info.options.icon_cluster;
		
		// Assemble render object.
		map_render_options.zoom = map_zoom;
		map_render_options.type = map_type;
		map_render_options.scroll_wheel = false;
		map_render_options.navigation_control = true;
		map_render_options.map_type_control = true;
		map_render_options.scale_control = true;
		map_render_options.draggable = true;
		map_render_options.location_icon_path = location_icon_path;
		map_render_options.map_custom_style = map_custom_style;
		map_render_options.icon_location = icon_location;
		map_render_options.icon_cluster = icon_cluster;
		//map_render_options.cluster_icon_path = cluster_icon_path;
		//map_render_options.cluster_icon_width = cluster_icon_width;
		//map_render_options.cluster_icon_height = cluster_icon_height;
		//map_render_options.cluster_icon_color = cluster_icon_color;
		
		return(map_render_options);
	}
};//end object literal Maps

jQuery(document).ready(function(jQuery){
	
	Maps.init();
	
});